import CustomButton from "../button"
import pen from "../../../src/assets/images/pen1.png";
import del from "../../../src/assets/images/del1.png";
import { toastMsg } from "../../component/toast";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFormField } from "../../pages/Slices/formSlice";
import check from "../../../src/assets/images/checkkk.svg";
import close from "../../../src/assets/images/x-close.svg";
import emptyErrorImg from "../../../src/assets/images/emptyErrorImg.png"

function EditSkillGroup({ handleClose, loadingForRegenerateSkills, regenerateSkillsAPI}) {

const state = useSelector((state) => state?.form);
const formData = useSelector((state) => state.form);
const dispatch = useDispatch();

const [skillGroups, setSkillGrups] = useState([...state.finalSkillsArray]);
const [skillsInAGroupByGroup, setSkillsInAGroupByGroup] = useState({});
const [feedbackForSkillRegeneration, setFeedbackForSkillRegeneration] = useState('');
const [isAddingGroup, setIsAddingGroup] = useState(false);
const [editingGroupName, setEditingGroupName] = useState(null);
const [isRegeneratedSkills, setIsRegeneratedSkills] = useState(false);
const [editedGroupNameValue, setEditedGroupNameValue] = useState('');
const [newGroupName, setNewGroupName] = useState('');
const [displayAiGenrtdDes, setAiGenertdDes] = useState(false);
 const [showSuggestionOriginalForResp, setShowSuggestionOriginalForResp] =
    useState(false);
const [selectedSkillsByGroup, setSelectedSkillsByGroup] = useState(() => {
  const initialMap = {};
  state.finalSkillsArray.forEach(group => {
    initialMap[group.group_name] = group.recommended_skills;
  });
  return initialMap;
});

useEffect(()=>{
  if(formData.finalSkillsArray){
    setSelectedSkillsByGroup(() => {
  const initialMap = {};
  state.finalSkillsArray.forEach(group => {
    initialMap[group.group_name] = group.recommended_skills;
  });
  return initialMap;
})
setCurrentGroupName(skillGroups[0]?.group_name || '')
  }
},[formData.finalSkillsArray])
const [currentGroupName, setCurrentGroupName] = useState(skillGroups[0]?.group_name || '');
const [addNewSkillInAGroup, setAddNewSkillInAGroup] = useState('');

useEffect(() => {
  if (formData.finalSkillsArray) {
    setSkillGrups([...formData.finalSkillsArray]);
  }
}, [formData.finalSkillsArray]);

// useEffect(() => {
//   const initialSkillsMap = {};
//   skillGroups.forEach(group => {
//     initialSkillsMap[group.group_name] = [
//       ...group.recommended_skills.map(skill => ({ name: skill, type: 'recommended' })),
//       ...group.unrecommended_skills.map(skill => ({ name: skill, type: 'unrecommended' }))
//     ];
//   });
//   setSkillsInAGroupByGroup(initialSkillsMap);
// }, [skillGroups]);

useEffect(() => {
  setSkillsInAGroupByGroup(prev => {
    const updatedMap = { ...prev };

    skillGroups.forEach(group => {
      if (!updatedMap[group.group_name]) {
        updatedMap[group.group_name] = [
          ...group.recommended_skills.map(skill => ({ name: skill, type: 'recommended' })),
          ...group.unrecommended_skills.map(skill => ({ name: skill, type: 'unrecommended' }))
        ];
      }
    });

    return updatedMap;
  });
}, [skillGroups]);

const maxSelectable = Math.floor((skillsInAGroupByGroup[currentGroupName]?.length || 0) * 0.7);

// const handleCheckboxToggle = (skillName) => {
//     setSelectedSkillsByGroup(prev => {
//       const current = prev[currentGroupName] || [];
//       const isSelected = current.includes(skillName);
//       const totalSkills = skillsInAGroupByGroup[currentGroupName]?.length || 0;
//       const maxAllowed = Math.floor(totalSkills * 0.7);
//       console.log('taleeb--',(selectedSkillsByGroup[currentGroupName] || []).length , maxAllowed )
//       if ((selectedSkillsByGroup[currentGroupName] || []).length  > maxAllowed   ){
//         console.log('yessss')
//         setKindOfError((prev)=>({
//           ...prev,
//           maxSelectedSkillsReached : true
//         }))
//       } else {
//         setKindOfError((prev)=>({
//           ...prev,
//           maxSelectedSkillsReached : false
//         }))
//       }
//   // taleeb
//       if (!isSelected) {
//         // const totalSkills = skillsInAGroupByGroup[currentGroupName]?.length || 0;
//         // const maxAllowed = Math.floor(totalSkills * 0.7);
//        
//         if (current.length >= maxAllowed) {
//           toastMsg('error', `You can only select up to ${maxAllowed} skills out of ${totalSkills}.`);
//           return prev; // prevent state update
//         }
//       }
//      
//   
//       const updated = isSelected
//         ? current.filter(name => name !== skillName)
//         : [...current, skillName];
//   
//       return {
//         ...prev,
//         [currentGroupName]: updated,
//       };
//     });
//   };
  

const handleCheckboxToggle = (skillName) => {
  setSelectedSkillsByGroup(prev => {
    const current = prev[currentGroupName] || [];
    const isSelected = current.includes(skillName);

    const totalSkills = skillsInAGroupByGroup[currentGroupName]?.length || 0;
    const maxAllowed = Math.floor(totalSkills * 0.7);

    // Step 1: Compute what the new selection would be
    const updated = isSelected
      ? current.filter(name => name !== skillName)
      : [...current, skillName];

    // Step 2: Check if the updated array exceeds the limit
    if (!isSelected && updated.length > maxAllowed) {
      toastMsg('error', `You can only select up to ${maxAllowed} skills out of ${totalSkills}.`);
      setKindOfError(prev => ({
        ...prev,
        maxSkillsReached: false,
        maxSelectedSkillsReached: true
      }));
      return prev; // don’t apply update
    }

    // Step 3: No error — allow update
    setKindOfError(prev => ({
      ...prev,
      maxSelectedSkillsReached: false
    }));

    return {
      ...prev,
      [currentGroupName]: updated
    };
  });
};


const handleGroupNameClick = (group_name) => {
  setErrorGroupName('')
  setKindOfError((prev)=>({
    ...prev,
    maxSelectedSkillsReached : false
  }))
    // const existingSkills =  [group_name];
    const existingSkills = skillsInAGroupByGroup[group_name];
  
    // If already edited (exists in memory), use that
    if (existingSkills) {
      setCurrentGroupName(group_name);
      return;
    }
  
    // Otherwise fallback to constructing from `skillGroups`
    const group = skillGroups.find(g => g.group_name === group_name);
    if (!group) return;
  
    let defaultSkills = [
      ...group.recommended_skills.map(skill => ({ name: skill, type: 'recommended' })),
      ...group.unrecommended_skills.map(skill => ({ name: skill, type: 'unrecommended' })),
    ];
  
    const selected = selectedSkillsByGroup[group_name] || [];
    const defaultSkillNames = defaultSkills.map(s => s.name.toLowerCase());
    const customMissing = selected.filter(sel => !defaultSkillNames.includes(sel.toLowerCase()));
  
    const fullSkills = [
      ...customMissing.map(skill => ({ name: skill, type: 'custom' })),
      ...defaultSkills
    ];
  
    setSkillsInAGroupByGroup(prev => ({
      ...prev,
      [group_name]: fullSkills
    }));
    setCurrentGroupName(group_name);
  };
  

const handleDeleteSkillFromGroup = (name) => {
  
  const currentSkills = skillsInAGroupByGroup[currentGroupName] || [];
  if (currentSkills.length <= 5) {
    toastMsg('error', "A group must have at least 5 skills.");
    return;
  }
 
  if(currentSkills.length < 12 ){
  
    setKindOfError((prev)=> ({
      ...prev,
      maxSkillsReached: false
    }))
  }
  const updatedSkills = currentSkills.filter(item => item.name !== name);
  setSkillsInAGroupByGroup(prev => ({
    ...prev,
    [currentGroupName]: updatedSkills
  }));

  setSelectedSkillsByGroup(prev => {
    const current = prev[currentGroupName] || [];
    const updated = current.filter(skill => skill.toLowerCase() !== name.toLowerCase());
    return {
      ...prev,
      [currentGroupName]: updated
    };
  });
};

const handleAddSkillToAGroup = () => {
  const currentSkills = skillsInAGroupByGroup[currentGroupName] || [];
  const selectedSkills = selectedSkillsByGroup[currentGroupName] || [];

  const totalSkills = currentSkills.length;
  const selectedCount = selectedSkills.length;
  const maxAllowed = Math.floor(totalSkills * 0.7);


  const skillName = addNewSkillInAGroup.trim();
  if (!skillName) return;

  const exists = (skillsInAGroupByGroup[currentGroupName] || []).some(
    skill => skill.name.toLowerCase() === skillName.toLowerCase()
  );

  if (exists) {
    toastMsg('error', "This Skill already exists.");
    return;
  }
// taleeb
  if ((skillsInAGroupByGroup[currentGroupName] || []).length >= 12) {
    toastMsg('error', "You can have a maximum of 12 skills in a group.");
    setKindOfError((prev)=>({
      ...prev,
      maxSkillsReached : true
    }))
    return;
  }
  

  const newSkill = { name: skillName, type: 'custom' };
  const updated = [newSkill, ...(skillsInAGroupByGroup[currentGroupName] || [])];
  setSkillsInAGroupByGroup(prev => ({
    ...prev,
    [currentGroupName]: updated
  }));

  // setSelectedSkillsByGroup(prev => ({
  //   ...prev,
  //   [currentGroupName]: [...(prev[currentGroupName] || []), skillName],
  // }));

  setAddNewSkillInAGroup('');
};

const [errorGroupName , setErrorGroupName] = useState('')
const [kindOfError , setKindOfError] = useState({
  lessThanFiveSkills : false,
})
  
const handleSaveFinalSkillSets = () => {

// Validate: Each group must have at least 5 skills
for (let group of skillGroups) {
  const allSkills = skillsInAGroupByGroup[group.group_name] || [];
  if (allSkills.length < 5) {
    toastMsg('error', `Group "${group.group_name}" must have at least 5 skills.`);
    setErrorGroupName(group.group_name)
    setKindOfError((prev)=>({
      ...prev,
      lessThanFiveSkills : true
    }))
    return; // Exit early
  } else {
    setKindOfError((prev)=>({
      ...prev,
      lessThanFiveSkills : false
    }))
  }
}

 // 2. Validate: At least 2 skills selected per group
 for (let group of skillGroups) {
  const selectedSkills = selectedSkillsByGroup[group.group_name] || [];
  if (selectedSkills.length < 2) {
    toastMsg('error', `Please select at least 2 skills in group "${group.group_name}".`);
    setErrorGroupName(group.group_name);
    setKindOfError(prev => ({
      ...prev,
      lessThanTwoSelectedSkills: true
    }));
    return;
  } else {
    setErrorGroupName('');
    setKindOfError(prev => ({
      ...prev,
      lessThanTwoSelectedSkills: false
    }));
  }
}
  // 3x. Validate: Total selected skills across all groups <= 12
  const totalSelectedSkills = Object.values(selectedSkillsByGroup)
    .flat()
    .length;

  if (totalSelectedSkills > 12) {
    toastMsg('error', `You can select a maximum of 12 skills across all groups. You have selected ${totalSelectedSkills}.`);
    setKindOfError(prev => ({
      ...prev,
      totalSelectedSkillsExceeded: true
    }));
    setKindOfError((prev)=>({
      ...prev,
      selectedMoreThanTwelveAcrossGroup : true
    }))
    return; // Exit early
  }
   


    const updatedFinalSkillsArray = skillGroups.map(group => {
      const groupName = group.group_name;
      const allSkills = skillsInAGroupByGroup[groupName] || [];
  
      const recommended_skills = selectedSkillsByGroup[groupName] || [];
      const unrecommended_skills = allSkills
        .map(skill => skill.name)
        .filter(skillName => !recommended_skills.includes(skillName));
  
      return {
        group_name: groupName,
        recommended_skills,
        unrecommended_skills
      };
    });
  
    // This is what user selected (for short list)
    const updatedSkillsRequiredForJob = updatedFinalSkillsArray.map(group => ({
      group_name: group.group_name,
      recommended_skills: group.recommended_skills
    }));
  
    // Dispatch both to Redux
    dispatch(updateFormField({ field: 'skillsRequiredForJob', value: updatedSkillsRequiredForJob }));
    dispatch(updateFormField({ field: 'finalSkillsArray', value: updatedFinalSkillsArray }));
  
    toastMsg('success', 'Skill groups saved successfully');
    handleClose()
  }; 

const handleAddSkillGroup = () => {
    if (!isAddingGroup) {
      setIsAddingGroup(true);
      return;
    }
  
    const name = newGroupName.trim();
    if (!name) {
      toastMsg('error', 'Please enter a group name.');
      return;
    }
  
    const exists = skillGroups.some(group => group.group_name.toLowerCase() === name.toLowerCase());
    if (exists) {
      toastMsg('error', 'This group name already exists.');
      return;
    }
  
    const newGroup = {
      group_name: name,
      recommended_skills: [],
      unrecommended_skills: []
    };
  
    setSkillGrups(prev => [...prev, newGroup]);
  
    // Also initialize in skill tracking states
    setSkillsInAGroupByGroup(prev => ({
      ...prev,
      [name]: []
    }));
    setSelectedSkillsByGroup(prev => ({
      ...prev,
      [name]: []
    }));
  
    // Reset input
    setNewGroupName('');
    setIsAddingGroup(false);
  
    // Optionally switch to the new group
    setCurrentGroupName(name);
  };

  const handleDeleteGroup = (groupName) => {
    // const confirmed = window.confirm(`Are you sure you want to delete the group "${groupName}"?`);
    // if (!confirmed) return;
  
    setSkillGrups(prev => prev.filter(group => group.group_name !== groupName));
  
    // Clean up skills & selection state
    setSkillsInAGroupByGroup(prev => {
      const updated = { ...prev };
      delete updated[groupName];
      return updated;
    });
  
    setSelectedSkillsByGroup(prev => {
      const updated = { ...prev };
      delete updated[groupName];
      return updated;
    });
  
    // Reset currentGroupName if it was the deleted one
    if (currentGroupName === groupName) {
      const remaining = skillGroups.filter(g => g.group_name !== groupName);
      setCurrentGroupName(remaining[0]?.group_name || '');
    }
  };
  
const handleClickRegenerate =async  () => {
 
 await regenerateSkillsAPI()
 dispatch(
       updateFormField({
         field: "feedbackForJobResponsibilities",
         value: "",
       })
     )
     setShowSuggestionOriginalForResp(true);
 setIsRegeneratedSkills(true)
}
   useEffect(() => {
     if(isRegeneratedSkills && formData?.finalSkillsArray){
      setCurrentGroupName(formData?.finalSkillsArray[0]?.group_name || '')
     }
   setIsRegeneratedSkills(false)
     return () => {
       
     }
   }, [isRegeneratedSkills, formData?.finalSkillsArray])
   

const handleEditGroupName = (groupName) => {
    setEditingGroupName(groupName);
    setEditedGroupNameValue(groupName); // prefill input
  };
  const handleSaveEditedGroupName = () => {
    const newName = editedGroupNameValue.trim();
    const oldName = editingGroupName;
  
    if (!newName || newName === oldName) {
      setEditingGroupName(null);
      return;
    }
  
    const nameExists = skillGroups.some(
      group => group.group_name.toLowerCase() === newName.toLowerCase() && group.group_name !== oldName
    );
  
    if (nameExists) {
      toastMsg('error', "Group name already exists.");
      return;
    }
  
    setSkillGrups(prev =>
      prev.map(group =>
        group.group_name === oldName
          ? { ...group, group_name: newName }
          : group
      )
    );
  
    setSkillsInAGroupByGroup(prev => {
      const updated = { ...prev, [newName]: prev[oldName] };
      delete updated[oldName];
      return updated;
    });
  
    setSelectedSkillsByGroup(prev => {
      const updated = { ...prev, [newName]: prev[oldName] };
      delete updated[oldName];
      return updated;
    });
  
    if (currentGroupName === oldName) {
      setCurrentGroupName(newName);
    }
  
    setEditingGroupName(null);
    setEditedGroupNameValue('');
  };

 const orgSuggForResp = (string) => {
    if (string === "original") {
      dispatch(
        updateFormField({
          field: "finalSkillsArray",
          value: formData.generatedSkillsArray,
        })
      );
      setAiGenertdDes(true);
    } else if (string === "suggestion") {
      dispatch(
        updateFormField({
          field: "finalSkillsArray",
          value: formData.reGeneratedSkillsArray,
        })
      );
      setAiGenertdDes(false);
    } else if (string === "final") {
      dispatch(
        updateFormField({
          field: "generatedSkillsArray",
          value: formData.finalSkillsArray,

        })
      );
      setShowSuggestionOriginalForResp(false);
    } else if (string === "close") {
      dispatch(
        updateFormField({
          field: "finalSkillsArray",
          value: formData.generatedSkillsArray,
        })
      );
      setShowSuggestionOriginalForResp(false);
    }
  };

  const getSkillGroupErrorMessage = () => {
    const currentSkills = skillsInAGroupByGroup[currentGroupName] || [];
    const selectedSkills = selectedSkillsByGroup[currentGroupName] || [];
  
    const totalSkills = currentSkills.length;
    const selectedCount = selectedSkills.length;
    const maxAllowed = Math.floor(totalSkills * 0.7);
  
    if (totalSkills < 5) {
      return 'This group cannot have less than 5 skills';
    }
  
    // if (selectedCount > maxAllowed) {
    //   return `You can only select ${maxAllowed} skills from this group`;
    // }
    if(kindOfError?.maxSkillsReached) {
      return `This group can have only 12 skills`
    }
    if (kindOfError?.maxSelectedSkillsReached){
      return `You can only select ${maxAllowed} skills from this group`
    }


    const totalSelectedSkills = Object.values(selectedSkillsByGroup)
    .flat()
    .length;

  if (totalSelectedSkills < 12) {
return
  }

      if (totalSelectedSkills > 12){
      return `You can select a maximum of 12 skills across all groups.`
    } 
  
    
    return null;
  };
    return (



<div className="p-1">
<div className="d-flex justify-content-between align-items-center">
  <h4 className="mb-0 fw-bold text-report-heading"> Skills Selection</h4>
 {/* <CustomButton
  title="Close"
  buttonType="secondary"
  handleClick={handleClose}
/> */}
<span style={{cursor:'pointer'}} onClick={handleClose}><svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.75659 5.39876L2.33993 7.81543C2.18715 7.96821 1.9927 8.0446 1.75659 8.0446C1.52048 8.0446 1.32604 7.96821 1.17326 7.81543C1.02048 7.66265 0.944092 7.46821 0.944092 7.2321C0.944092 6.99599 1.02048 6.80154 1.17326 6.64876L3.58993 4.2321L1.17326 1.83626C1.02048 1.68349 0.944092 1.48904 0.944092 1.25293C0.944092 1.01682 1.02048 0.822374 1.17326 0.669596C1.32604 0.516819 1.52048 0.44043 1.75659 0.44043C1.9927 0.44043 2.18715 0.516819 2.33993 0.669596L4.75659 3.08626L7.15243 0.669596C7.3052 0.516819 7.49965 0.44043 7.73576 0.44043C7.97187 0.44043 8.16631 0.516819 8.31909 0.669596C8.48576 0.836263 8.56909 1.03418 8.56909 1.26335C8.56909 1.49251 8.48576 1.68349 8.31909 1.83626L5.90243 4.2321L8.31909 6.64876C8.47187 6.80154 8.54826 6.99599 8.54826 7.2321C8.54826 7.46821 8.47187 7.66265 8.31909 7.81543C8.15243 7.9821 7.95451 8.06543 7.72534 8.06543C7.49618 8.06543 7.3052 7.9821 7.15243 7.81543L4.75659 5.39876Z" fill="#3A4B68"/>
</svg>
</span>

</div>
<div className="d-flex justify-content-between align-items-center mt-3 groupbar">
  <div className="d-flex gap-2 flex-wrap w-100">
  {skillGroups?.map((group, index) => ( 
  <div key={index} style={{ flex: `0 0 calc(${skillGroups.length === 2 ? '50%' : '33%'} - 0.5rem)` }}>
    <div className={`skillGroup d-flex justify-content-evenly align-items-center ${currentGroupName === group.group_name ? 'selected-Skill-group' : ''} ${errorGroupName ===  group.group_name ? 'error-skill-group' : ''}`}>
      
      {
        editingGroupName === group.group_name ? (
            <>
          <input
            type="text"
            value={editedGroupNameValue}
            onChange={(e) => setEditedGroupNameValue(e.target.value)}
            onBlur={handleSaveEditedGroupName}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSaveEditedGroupName();
              if (e.key === 'Escape') setEditingGroupName(null);
            }}
            autoFocus
           style={{ 
              height: "35px", 
             
              position: 'relative' // changed from absolute
            }}
    className=" p-2  rounded-md bg-gray-100 border border-grey text-black jb-in-1"
          />
         
      </>  ) : (
          <span
            className={`${currentGroupName === group.group_name ? 'selected-Skill-group---' : ''}`}
            onClick={() => handleGroupNameClick(group.group_name)}
          
          >
            {group?.group_name}
          </span>
        )
      }

      <div className="ml-1">
        <img
          src={pen}
          height={20}
          width={20}
          alt="edit"
          style={{ cursor: "pointer" }}
          onClick={() => handleEditGroupName(group.group_name)}
        />
        <img
          src={del}
          height={20}
          width={20}
          alt="delete"
          style={{ cursor: "pointer" }}
          onClick={() => handleDeleteGroup(group.group_name)}
        />
      </div>
    </div>
  </div>
))}
  </div>
  <div className="d-flex flex-column gap-2">
  {isAddingGroup && (
  <input
    name="locationJobDetails"
    type="text"
    value={newGroupName}
    onChange={(e) => setNewGroupName(e.target.value)}
    placeholder="Enter group name"
    style={{ height: "38px" }}
    className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1"
  />
)}
<CustomButton
  title="Add Skill Group"
  buttonType="secondary"
  handleClick={handleAddSkillGroup}
/>
  </div>
</div>
<div className="mt-3 boxAddEditGroup row">
  <div className="col-md-6 skillsList">
    <div className="d-flex gap-1">
      <input
        placeholder="Add a new skill here"
        name="locationJobDetails"
        type="text"
        className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
        style={{ height: "36px" }}
        value={addNewSkillInAGroup}
        onChange={(e) => setAddNewSkillInAGroup(e.target.value)}
      />
      <CustomButton
        title='Add'
        buttonType='secondary'
        handleClick={handleAddSkillToAGroup}
      />
      {console.log('selectedSkillsByGroup--', selectedSkillsByGroup)}
      {console.log('skillsInAGroupByGroup--', skillsInAGroupByGroup)}
    </div>
    { skillsInAGroupByGroup[currentGroupName]?.length > 0 ? ( (skillsInAGroupByGroup[currentGroupName] || []).map((i, index) => (
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-2 mt-1">
          <input
            type="checkbox"
            style={{ margin: 0 }}
            checked={selectedSkillsByGroup[currentGroupName]?.includes(i.name)}
            onChange={() => handleCheckboxToggle(i.name)}
          />
          <h6 className="mb-0 fw-medium font-size-h4">{i.name}</h6>
        </div>
        <img
          src={del}
          height={30}
          width={30}
          alt="delete"
          style={{ cursor: "pointer" }}
          onClick={() => handleDeleteSkillFromGroup(i.name)}
        />
      </div>
    )) ) : ( <div className='edit-skill-empty-grp-msg'><p>    This group is empty. Add skills now or use AI to generate them automatically. </p>
   <div className='d-flex'>
    <img className='m-auto' src={emptyErrorImg}  width={40} height={40}/>
    </div>
     </div>)}
 
  </div>

  
  <div className="col-md-6">
  {showSuggestionOriginalForResp ? (
                    <div className="d-flex justify-content-end mb-2">
                      <button
                        className={`buttonCusSug ${displayAiGenrtdDes && "colorActve"
                          }`}
                        onClick={() => orgSuggForResp("original")}
                      >
                        Original
                      </button>
                      <button
                        className={`buttonCusSug ${!displayAiGenrtdDes && "colorActve"
                          }`}
                        onClick={() => orgSuggForResp("suggestion")}
                      >
                        Suggestion
                      </button>
                      <button
                        className="buttonCusSug"
                        onClick={() => orgSuggForResp("final")}
                      >
                        {" "}
                        <img src={check} style={{ width: "20px" }} />
                      </button>
                      <button
                        className="buttonCusSug"
                        onClick={() => orgSuggForResp("close")}
                      >
                        {" "}
                        <img src={close} style={{ width: "20px" }} />
                      </button>
                    </div>
                  ) : null}
    <textarea
      name="descriptionAboutJob"
      rows={8}
      placeholder="Type your instructions here"
      className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
      value={formData.feedbackForSkillRegeneration}
      onChange={(e) => dispatch(updateFormField({ field: 'feedbackForSkillRegeneration', value: e.target.value }))}
    />
    <div className="d-flex justify-content-end ">
      <CustomButton
        title='Regenerate'
        isLoading={loadingForRegenerateSkills}
        handleClick={handleClickRegenerate}
        buttonType={'secondary'}
      />
    </div>
    <div className="mt-1 skilllgroupinstruction ">
      <h6 className="fw-bold text-sm">Note :</h6>
      <li className={`${kindOfError.lessThanFiveSkills ? 'edit-skill-instructions-error' :'' } `}>A group must have min 5 & max 12 skills</li>
      
      <li className={`${kindOfError.selectedMoreThanTwelveAcrossGroup ? 'edit-skill-instructions-error' :'' } `}>Across all groups combined, you can select a maximum of 12 skills.</li>
      <li>You may select a maximum of 70% of skills in any group</li>
      
      <li className={`${kindOfError.lessThanTwoSelectedSkills ? 'edit-skill-instructions-error' :'' } `}>You must select a minimum of 2 skills from each group</li>
    </div>
    <div className="d-flex justify-content-end">
      <span className="mt-1 fw-medium text-muted text-base">{`Total Skills Selected ${selectedSkillsByGroup[currentGroupName]?.length || 0} / ${skillsInAGroupByGroup[currentGroupName]?.length || 0}`}</span>
    </div>
  </div>
{console.log('skillsInAGroupByGroup[currentGroupName]?.length--',(skillsInAGroupByGroup[currentGroupName]?.length < 5) || (selectedSkillsByGroup[currentGroupName]?.length > Math.floor(skillsInAGroupByGroup[currentGroupName]?.length * 0.7)) )}
  {/* {(skillsInAGroupByGroup[currentGroupName]?.length < 5)  && (
  <div className='skill-groups-below-error col-md-6'> 
     <div>
     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.99985 5.00015V7.66682M7.99985 10.3335H8.00651M7.07673 1.59464L1.59347 11.0657C1.28933 11.591 1.13726 11.8537 1.15974 12.0693C1.17934 12.2573 1.27786 12.4282 1.43076 12.5394C1.60607 12.6668 1.90957 12.6668 2.51659 12.6668H13.4831C14.0901 12.6668 14.3936 12.6668 14.5689 12.5394C14.7218 12.4282 14.8204 12.2573 14.84 12.0693C14.8624 11.8537 14.7104 11.591 14.4062 11.0657L8.92297 1.59463C8.61992 1.07119 8.4684 0.809471 8.27071 0.721569C8.09828 0.644894 7.90142 0.644894 7.72898 0.721569C7.53129 0.809471 7.37977 1.07119 7.07673 1.59464Z" stroke="#880D1E" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</div>
    <p> {selectedSkillsByGroup[currentGroupName]?.length > Math.floor(skillsInAGroupByGroup[currentGroupName]?.length * 0.7) ? `You can only select ${Math.floor(skillsInAGroupByGroup[currentGroupName]?.length * 0.7)} skill from this group` : `This group cannot have less than 5 skills`}   </p>

     </div>
    )} */}
    {getSkillGroupErrorMessage() && (
  <div className='skill-groups-below-error col-md-6'> 
    <div>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.99985 5.00015V7.66682M7.99985 10.3335H8.00651M7.07673 1.59464L1.59347 11.0657C1.28933 11.591 1.13726 11.8537 1.15974 12.0693C1.17934 12.2573 1.27786 12.4282 1.43076 12.5394C1.60607 12.6668 1.90957 12.6668 2.51659 12.6668H13.4831C14.0901 12.6668 14.3936 12.6668 14.5689 12.5394C14.7218 12.4282 14.8204 12.2573 14.84 12.0693C14.8624 11.8537 14.7104 11.591 14.4062 11.0657L8.92297 1.59463C8.61992 1.07119 8.4684 0.809471 8.27071 0.721569C8.09828 0.644894 7.90142 0.644894 7.72898 0.721569C7.53129 0.809471 7.37977 1.07119 7.07673 1.59464Z" 
        stroke="#880D1E" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
    <p>{getSkillGroupErrorMessage()}</p>
  </div>
)}
  <div className="d-flex justify-content-end mt-2">
    <CustomButton title='Save' handleClick={handleSaveFinalSkillSets} />
  </div>
</div>
</div>


    )

}

export default EditSkillGroup